module.exports = __webpack_public_path__ + "static/img/cert5.473dd22.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cert5.png
// module id = K/UD
// module chunks = 1